import React from 'react';
import './SuggestedQuestions.css';

const SuggestedQuestions = ({ topicId, onQuestionSelect }) => {
  const suggestedQuestions = {
    anxiety_treatment: [
      "What's the difference between CBT and medication for anxiety?",
      "How effective is mindfulness for anxiety disorders?",
      "What are the side effects of anxiety medications?",
      "Can anxiety be cured or just managed?"
    ],
    digital_vs_traditional: [
      "Is online therapy as effective as in-person sessions?",
      "What are the benefits of digital therapy?",
      "How do you build trust in online therapy?",
      "What about privacy concerns with digital therapy?"
    ],
    work_life_balance: [
      "How do you prevent burnout in high-stress jobs?",
      "What's the role of boundaries in work-life balance?",
      "How do you deal with work-related anxiety?",
      "Is it possible to have perfect work-life balance?"
    ],
    depression_treatment: [
      "When should someone consider medication for depression?",
      "How long does therapy take to work for depression?",
      "What's the difference between sadness and depression?",
      "Can exercise really help with depression?"
    ],
    child_psychology: [
      "At what age should children start therapy?",
      "How do you know if a child needs professional help?",
      "What role do parents play in child therapy?",
      "How do you make therapy fun for children?"
    ],
    sleep_disorders: [
      "What's the best treatment for chronic insomnia?",
      "How do sleep medications affect mental health?",
      "Can CBT-I work without medication?",
      "What lifestyle changes improve sleep?"
    ]
  };

  const questions = suggestedQuestions[topicId] || suggestedQuestions.anxiety_treatment;

  return (
    <div className="suggested-questions">
      <h4>💡 Suggested Questions to Get Started:</h4>
      <div className="questions-grid">
        {questions.map((question, index) => (
          <button
            key={index}
            className="question-button"
            onClick={() => onQuestionSelect(question)}
            title="Click to use this question"
          >
            {question}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions;
